import * as React from "react";
import {
    AppBar, Autocomplete,
    Backdrop,
    Box,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    IconButton,
    Pagination,
    PaginationItem,
    Radio,
    RadioGroup,
    Slide,
    Tab,
    Tabs, TextField,
    Toolbar,
    Typography
} from "@mui/material";

import NavBar from "../components/NavBar";
import {ReactComponent as NegativeStore} from "./../assets/img/icons/negativeStore.svg";
import {ReactComponent as Wallet} from "./../assets/img/icons/wallet.svg";
import {
    convertPrice,
    handleBorderColor,
    HandlerShowMessage,
    handleScrollIntoView,
    handleSetServicesLogo
} from "../assets/js/main";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import {createSearchParams, Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {ArrowBack, ArrowForward, Clear, Close, CreditScore, Edit} from "@mui/icons-material";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../redux/loading/actions";
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en"
import DateObject from "react-date-object";
import HandleFetchData from "../plugin/HandleFetchData";
import {ThemeContext} from "../App";
import {setShipmentType} from "../redux/singleOrder/infoBox/actions";
import {
    setCityIDSender,
    setCityNameSender, setLatSender, setLngSender,
    setStateIDSender,
    setStateNameSender
} from "../redux/singleOrder/sender/actions";
import {
    setCityIDReceiver,
    setCityNameReceiver, setLatReceiver, setLngReceiver,
    setStateIDReceiver,
    setStateNameReceiver
} from "../redux/singleOrder/receiver/actions";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function OrderList() {
    const {t} = useTranslation()
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {fetchData} = HandleFetchData()
    const {showMessage} = HandlerShowMessage();

    // استفاده از useLocation در react-router-dom برای گرفتن اطلاعات صفحه جاری
    const location = useLocation();
    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const divarIncomId = searchParams.get('state')
    const theme = React.useContext(ThemeContext)

    const descRef = React.useRef()

    const [_loading, set_Loading] = React.useState(false);
    const [tabView, setTabView] = React.useState('پرداخت شده');
    const [listOrder, setListOrder] = React.useState([]);
    const [shipmentList, setShipmentList] = React.useState([]);
    const [payMethods, setPayMethods] = React.useState([]);
    const [idOrder, setIdOrder] = React.useState(null)
    const [creditOrder, setCreditOrder] = React.useState(null)
    const [pageNum, setPageNum] = React.useState(1)
    const [pageSize, setPageSize] = React.useState(12)
    const [hasMore, setHasMore] = React.useState(true)
    const [radio, setRadio] = React.useState("");
    const [search, setSearch] = React.useState("");
    const [receiver, setReceiver] = React.useState(null);
    const [receiverReport, setReceiverReport] = React.useState('');
    const [fromDate, setFromDate] = React.useState(null);
    const [toDate, setToDate] = React.useState(null);
    const [fromDateReport, setFromDateReport] = React.useState(null);
    const [toDateReport, setToDateReport] = React.useState(null);
    const [dialogPaymentMethods, setDialogPaymentMethods] = React.useState(false)
    const [dialogCancelOrder, setDialogCancelOrder] = React.useState(false)
    const [showSearchItems, setShowSearchItems] = React.useState(false)
    const [showReportItems, setShowReportItems] = React.useState(false)
    const [dialogDetailsOrder, setDialogDetailsOrder] = React.useState(false)
    const [dialogListOrder, setDialogListOrder] = React.useState(false)
    const [orderId, setOrderId] = React.useState();
    const [desc, setDesc] = React.useState('');
    const [fullName, setFullName] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [detailsItem, setDetailsItem] = React.useState({});
    const [validations, setValidations] = React.useState({});
    const [_isLoading, _setIsLoading] = React.useState(false);
    const [reportId, setReportId] = React.useState('');
    const [orderSerialFrom, setOrderSerialFrom] = React.useState('');
    const [orderSerialTo, setOrderSerialTo] = React.useState('');
    const [payStatus, setPayStatus] = React.useState('');
    const [orderStatus, setOrderStatus] = React.useState('');
    const [recieverProvinceId, setRecieverProvinceId] = React.useState('');
    const [recieverCityId, setRecieverCityId] = React.useState('');
    const [senderProvinceId, setSenderProvinceId] = React.useState('');
    const [senderCityId, setSenderCityId] = React.useState('');
    const [listStateAndCity, setListStateAndCity] = React.useState([])
    const [textStateAndCitySender, setTextStateAndCitySender] = React.useState('')
    const [textStateAndCityReceiver, setTextStateAndCityReceiver] = React.useState('')

    React.useEffect(() => {
        getListOrder(pageNum)
    }, [pageNum])


    React.useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem('info-user'))

        setFullName(userInfo?.FullName)
        setPhone(userInfo?.Mobile)
        handleGetStateAndCity()
    }, [])

    const getListOrder = async (e) => {
        dispatch(setLoading(true))
        setTimeout(async () => {
            let fetch = await fetchData('', 'POST', '/getCustomerOrder', {
                    "pageSize": pageSize,
                    "pageIndex": Number(e),
                    "ServiceId": 0,
                    "OrderIdFrom": Number(search) || 0,
                    "OrderIdTo": Number(search) || 0,
                    "PayStatus": 0,
                    "OrderStatus": 0,
                    "RecieverProvinceId": 0,
                    "RecieverCityId": 0,
                    "SenderProvinceId": 0,
                    "SenderCityId": 0,
                    "RecieverName": receiver,
                    "FromDate": fromDate ? new DateObject(fromDate).convert(persian, persian_en).format("YYYY-MM-DDThh:mm:ss") : "",
                    "ToDate": toDate ? new DateObject(toDate).convert(persian, persian_en).format("YYYY-MM-DDThh:mm:ss") : "",
                },
                "application/vnd.api+json", '', '', ''
            )

            if (fetch?.Data?.length) {
                setListOrder(fetch?.Data)
                // setListOrder([...listOrder, ...fetch?.Data])
            } else if (fetch && fetch?.Status?.toString() === String(500)) {
                navigate({
                    pathname: "/pageInternalServer",
                    search: location?.search

                });
            } else {
                setListOrder([])
                setHasMore(false)
            }
            dispatch(setLoading(false))
        }, 1000)
    }

    const handleGetShipmentList = async (e) => {
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'GET', '/prevOrderInfo', '', "text/html",{
            orderId: e
        }, '','')

        if(fetch?.success){
            setShipmentList(fetch?.data || [])
            setDialogListOrder(true)
        }else{
            enqueueSnackbar(fetch?.message, {
                variant: 'error',
                TransitionProps: {
                    direction: 'down',
                },
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'top'
                }
            })
        }

        setOrderId(e)
        dispatch(setLoading(false))
    }

    const validationInput = () => {
        if (!desc) {
            handleScrollIntoView(descRef)
            setValidations({
                desc: 'وارد کردن توضیحات الزامی میباشد'
            })
        }else if(!fullName){
            enqueueSnackbar('اکانت شما فاقد نام و نام خانوادگی میباشد', {
                variant: 'error',
                TransitionProps: {
                    direction: 'down',
                },
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'top'
                }
            })
        } else {
            handleCancelOrder()
        }
    }

    const handleCancelOrder = async () => {
        setValidations({})
        _setIsLoading(true)
        let fetch = await fetchData('ticketing', 'POST', '/v1/OrderCancellation', {
                "fullName": fullName || '',
                "mobileNumber": phone,
                "orderNo": orderId,
                "description": desc,
            },
            "application/json", '', 'postex', 'HiCMSPostexAdmin@1402'
        )
        showMessage(fetch?.status)
        if (fetch?.success) {
            setDialogCancelOrder(false)
            setDesc('')
        }
        _setIsLoading(false)

    }
    const handleGetStateAndCity = async (e) => {
        set_Loading(true)
        let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
            "term": e
        }, 'postex')
        setListStateAndCity(fetch?.data)
        const item = fetch?.data.find(e => e.id === '1-1')
        set_Loading(false)
    }
    const handleSetInfoStateAndCity = (value, flag) => {
        let id = e => value?.id?.split('-')[e]

        if (flag === 'sender') {
            setSenderCityId(id(1) || '')
            setSenderProvinceId(id(0) || '')
        } else {
            setRecieverCityId(id(1) || '')
            setRecieverProvinceId(id(0) || '')
        }
    }

    const handleDetailsOrder = async (e) => {
        _setIsLoading(true)
        let fetch = await fetchData('nbl', 'GET', `/v1/Order/${e}`, "",
            "application/json", '', 'postex', ''
        )
        // showMessage(fetch?.status)
        if (fetch?.isSuccess) {
            setDialogDetailsOrder(true)
            setDetailsItem(fetch?.data[0])
        }
        _setIsLoading(false)

    }

    const payOrder = async () => {
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'POST', '/payment', {
                "orderId": Number(idOrder),
                "paymentmethod": radio === "Payments.Wallet" ? "" : radio,
                "useRewardPoints": radio === "Payments.Wallet",
                "isForeign": false,
                "reciverPay": false,
                "DivarToken": divarIncomId || null,
                "callBackUrl": `https://${process.env.REACT_APP_SUBDOMAIN}.postex.ir/paymentStatus`
            },
            "application/json", '', '', ''
        )
        if (fetch?.IsSuccess) {
            if (radio === "Payments.Wallet") {
                navigate({
                    pathname: "/paymentStatus",
                    search: createSearchParams({
                        OrderId: fetch?.Data?.orderId,
                        code: 0,
                        state: fetch?.Data?.divarToken
                    })?.toString()
                });
                enqueueSnackbar(fetch?.Message, {
                    variant: 'success',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            } else {
                window.open(fetch?.Data, '_self')
            }
        } else if (fetch && fetch?.StatusCode == 500) {
            navigate({
                pathname: "/pageInternalServer",
                search: location?.search
            });
        } else {
            enqueueSnackbar(fetch?.Message, {
                variant: 'error',
                TransitionProps: {
                    direction: 'down',
                },
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'top'
                }
            })
        }
        dispatch(setLoading(false))
    }

    const getPaymentMethods = async (id, credit) => {
        setIdOrder(id)
        setCreditOrder(credit)
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'GET', '/getPaymentMethod', '',
            "application/json", {
                "orderId": String(id),
                "paymentMethodForId": "1"
            }, '', ''
        )

        if (fetch?.Data) {
            setPayMethods(fetch?.Data)
            setDialogPaymentMethods(true)
        }

        dispatch(setLoading(false))
    }

    const handlerDownload = async (id) => {
        dispatch(setLoading(true))
        const pdfUrl = `https://postex.ir/api/order/getpdfinvoice/${id}`; // Replace with the actual PDF URL
        const myHeaders = new Headers();
        myHeaders.append("token", localStorage.getItem('token'));

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(pdfUrl, requestOptions).then(response => response.blob()).then(blob => {
            const pdfWindow = window.open();
            const fileURL = URL.createObjectURL(blob);
            // const link = document.createElement('a');
            // link.href = window.URL.createObjectURL(blob);
            // link.download = `${+new Date()}.pdf`;
            // link.click();
            if (pdfWindow) {
                pdfWindow.location.href = fileURL;
            }
            dispatch(setLoading(false))
        }).catch(error => {
            console.log('error', error)
            dispatch(setLoading(false))
        });
    }


    const handleSearch = () => {
        getListOrder(1)
    }

    const handleShowSearchItems = () => {
        setShowSearchItems(!showSearchItems)
    }
    const handleShowReportItems = () => {
        setShowReportItems(!showReportItems)
    }

    const handleReports = async () => {
        const Url = 'https://postex.ir/api/downloadReport?'+ new URLSearchParams({
            "reportId": reportId,
            "orderSerialFrom": orderSerialFrom,
            "orderSerialTo": orderSerialTo,
            "payStatus": payStatus,
            "orderStatus": orderStatus,
            "recieverName": receiverReport,
            "recieverProvinceId": recieverProvinceId,
            "recieverCityId": recieverCityId,
            "senderProvinceId": senderProvinceId,
            "senderCityId": senderCityId,
            "fromDate": fromDateReport ? new DateObject(new Date(fromDateReport)).convert(persian, persian_en).format("YYYY-MM-DD") : "",
            "toDate": toDateReport ? new DateObject(new Date(toDateReport)).convert(persian, persian_en).format("YYYY-MM-DD") : "",
        }); // Replace with the actual PDF URL
        const myHeaders = new Headers();
        myHeaders.append("token", localStorage.getItem('token'));
        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        }
        fetch(Url, requestOptions)
            .then(response => response.blob())
            .then(blob => {
                dispatch(setLoading(false))
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = reportId === '3' ? `${+new Date()}.pdf` : `${+new Date()}.xlsx`;
                link.click();
            })
            .catch(error => {
                console.log('error', error)
                dispatch(setLoading(false))
            });

        // let fetch = await fetchData('', 'GET', '/downloadReport', '',
        //     "application/json", {
        //         "reportId": reportId,
        //         "orderSerialFrom": orderSerialFrom,
        //         "orderSerialTo": orderSerialTo,
        //         "payStatus": payStatus,
        //         "orderStatus": orderStatus,
        //         "recieverName": receiverReport,
        //         "recieverProvinceId": recieverProvinceId,
        //         "recieverCityId": recieverCityId,
        //         "senderProvinceId": senderProvinceId,
        //         "senderCityId": senderCityId,
        //         "fromDate": fromDateReport ? new DateObject(fromDateReport).convert(persian, persian_en).format("YYYY-MM-DD") : "",
        //         "toDate": toDateReport ? new DateObject(toDateReport).convert(persian, persian_en).format("YYYY-MM-DD") : "",
        //     }, '', ''
        // )
        //
        // const blob = new Blob([fetch], { type: reportId === '3' ? "application/pdf" : "" });
        // const link = document.createElement('a');
        // link.href = window.URL.createObjectURL(blob);
        // link.download = reportId === '3' ? `${+new Date()}.pdf` : `${+new Date()}.xls`;
        // link.click();
    }

    return (
        <>
            {selector?.loading?.isLoading &&
                <div className="backdrop-loading">
                    <div className="backdrop-bg">
                        <div className="loader"
                             style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
                    </div>
                </div>
            }

            {(location.pathname === '/orderList' || location.pathname === '/divar/orderList') &&
                <NavBar blue back/>
            }


            <div className="container">
                <div className="orderListPage desktopSection">
                    <div className="d-flex align-items-center justify-content-between">
                        <h4 className="titleSection">{t("dashboard.order.t1")}</h4>
                        <div className="btnGroup_light ml-0 mt-2">
                            <button type="button" className="btnFill justify-content-center"
                                    onClick={handleShowSearchItems} id="textPrice">
                                <span>{showSearchItems ? t("dashboard.order.t22") : t("dashboard.order.t21")}</span>
                            </button>
                            <button type="button" className="btnFill justify-content-center"
                                    onClick={handleShowReportItems} id="textPrice">
                                <span>{showReportItems ? t("dashboard.order.t22") : t("dashboard.order.t65")}</span>
                            </button>
                        </div>
                    </div>
                    {
                        showSearchItems &&
                        <div className="search">
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>{t("dashboard.order.t11")}</label>
                                    <input type="text" autoComplete="on" name="receiver"
                                           value={receiver} id="receiver"
                                           onChange={e => setReceiver(e?.target?.value)}/>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>{t("dashboard.order.t6")}</label>
                                    <input type="text" autoComplete="on" name="search"
                                           value={search} id="search"
                                           onChange={e => setSearch(e?.target?.value)}/>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>{t("dashboard.order.t19")}</label>
                                    <div className="date-picker">
                                        <DatePicker
                                            id="setFromDate"
                                            calendar={persian}
                                            locale={persian_fa}
                                            value={fromDate}
                                            onChange={e => setFromDate(e)}
                                        />
                                        <button type="button" onClick={() => setFromDate(null)} id="fromDate">
                                            <Clear/>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>{t("dashboard.order.t20")}</label>
                                    <div className="date-picker">
                                        <DatePicker
                                            id="setToDate"
                                            calendar={persian}
                                            locale={persian_fa}
                                            value={toDate}
                                            onChange={e => setToDate(e)}
                                        />
                                        <button type="button" onClick={() => setToDate(null)} id="toDate">
                                            <Clear/>
                                        </button>
                                    </div>

                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <div className="_btnGroup_blue mb-0">
                                        <button className="btnFill justify-content-center" onClick={handleSearch}
                                                id="handleSearch">
                                            <span>{t("dashboard.order.t21")}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        showReportItems &&
                        <div className="search">
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>{t("dashboard.order.t11")}</label>
                                    <input type="text" autoComplete="on" name="receiverReport"
                                           value={receiverReport} id="receiverReport"
                                           onChange={e => setReceiverReport(e?.target?.value)}/>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>نوع گزارش</label>
                                    <select aria-label="Default select example"
                                            id="reportId"
                                            value={reportId}
                                            onChange={(event) => setReportId(event?.target?.value)}>

                                        <option value="">انتخاب کنید</option>
                                        <option value="1">3000 سفارش آخر</option>
                                        <option value="2">3000 سفارش آخر با جزئیات</option>
                                        <option value="3">خروجی بارکد سفارشاتpdf</option>
                                        <option value="4">خروجی بارکد سفارشاتxls</option>
                                        <option value="5">ریز واریزی حق نمایندگی به کیف پول xls</option>
                                        <option value="6">ریز واریزی بایت خدمات نمایندگی به کیف پول xls</option>
                                        <option value="7">گزارش با کد رهگیری xls</option>

                                    </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>وضعیت پرداخت</label>
                                    <select aria-label="Default select example"
                                            id="reportId"
                                            value={payStatus}
                                            onChange={(event) => setPayStatus(event?.target?.value)}>

                                        <option value="">انتخاب کنید</option>
                                        <option value="10">معلق</option>
                                        <option value="20">درحال پردازش</option>
                                        <option value="30">تکمیل</option>
                                        <option value="40">منصرف شده</option>
                                    </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>وضعیت سفارش</label>
                                    <select aria-label="Default select example"
                                            id="reportId"
                                            value={orderStatus}
                                            onChange={(event) => setOrderStatus(event?.target?.value)}>

                                        <option value="">انتخاب کنید</option>
                                        <option value="10"> پرداخت نشده</option>
                                        <option value="30">پرداخت شده</option>
                                    </select>
                                </div>

                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>از شماره سفارش</label>
                                    <input type="text" autoComplete="on" name="orderSerialFrom"
                                           value={orderSerialFrom} id="orderSerialFrom"
                                           onChange={e => setOrderSerialFrom(e?.target?.value)}/>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>تا شماره سفارش</label>
                                    <input type="text" autoComplete="on" name="orderSerialTo"
                                           value={orderSerialTo} id="orderSerialTo"
                                           onChange={e => setOrderSerialTo(e?.target?.value)}/>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>{t("dashboard.order.t19")}</label>
                                    <div className="date-picker">
                                        <DatePicker
                                            id="fromDateReport"
                                            calendar={persian}
                                            locale={persian_fa}
                                            value={fromDateReport}
                                            onChange={e => setFromDateReport(e)}
                                        />
                                        <button type="button" onClick={() => setFromDateReport(null)} id="_fromDateReport">
                                            <Clear/>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label>{t("dashboard.order.t20")}</label>
                                    <div className="date-picker">
                                        <DatePicker
                                            id="setToDateReport"
                                            calendar={persian}
                                            locale={persian_fa}
                                            value={toDateReport}
                                            onChange={e => setToDateReport(e)}
                                        />
                                        <button type="button" onClick={() => setToDateReport(null)} id="toDateReport">
                                            <Clear/>
                                        </button>
                                    </div>

                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <label>{t("singleOrder.sender.t19")}</label>
                                    <Autocomplete
                                        inputValue={textStateAndCitySender}
                                        defaultValue={textStateAndCitySender}
                                        noOptionsText={t("autoComplete.t1")}
                                        id="city-state-sender"
                                        disablePortal
                                        autoHighlight
                                        loading={_loading}
                                        onChange={(e, value, reason) => {
                                            if (reason === 'clear') {
                                                setTextStateAndCitySender('')
                                                handleSetInfoStateAndCity(null, 'sender')
                                            } else {
                                                setTextStateAndCitySender(value?.name)
                                                handleSetInfoStateAndCity(value, 'sender')
                                            }
                                        }}
                                        options={listStateAndCity || []}
                                        getOptionLabel={(option) => option?.name || ''}
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                       hiddenLabel
                                                       size="small"
                                                       style={handleBorderColor(selector?.public?.validations?.state_and_city_validation_Sender)}
                                                       placeholder={t("singleOrder.sender.t24")}
                                                       onChange={(event) => {
                                                           setTextStateAndCitySender(event?.target?.value)
                                                           event?.target?.value?.length > 1 ? handleGetStateAndCity(event?.target?.value) : handleSetInfoStateAndCity(null, 'sender')
                                                       }}
                                                       InputProps={{
                                                           ...params.InputProps,
                                                           endAdornment: (
                                                               <React.Fragment>
                                                                   {_loading ?
                                                                       <CircularProgress style={{margin: '0 5px'}}
                                                                                         size={20}/>
                                                                       : null}
                                                                   {params.InputProps.endAdornment}
                                                               </React.Fragment>
                                                           ),
                                                       }}
                                            />}
                                    />
                                    {
                                        selector?.public?.validations?.state_and_city_validation_Sender &&
                                        <p className="error">{selector?.public?.validations?.state_and_city_validation_Sender}</p>
                                    }
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <label>{t("singleOrder.receiver.t19")}</label>
                                    <Autocomplete
                                        inputValue={textStateAndCityReceiver}
                                        defaultValue={textStateAndCityReceiver}
                                        noOptionsText={t("autoComplete.t1")}
                                        id="city-state-receiver"
                                        disablePortal
                                        autoHighlight
                                        loading={_loading}
                                        onChange={(e, value, reason) => {
                                            if (reason === 'clear') {
                                                setTextStateAndCityReceiver('')
                                                handleSetInfoStateAndCity(null, 'receiver')
                                            } else {
                                                setTextStateAndCityReceiver(value?.name)
                                                handleSetInfoStateAndCity(value, 'receiver')
                                            }
                                        }}
                                        options={listStateAndCity || []}
                                        getOptionLabel={(option) => option?.name || ''}
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                       hiddenLabel
                                                       size="small"
                                                       style={handleBorderColor(selector?.public?.validations?.state_and_city_validation_Receiver)}
                                                       placeholder={t("singleOrder.receiver.t24")}
                                                       onChange={(event) => {
                                                           setTextStateAndCityReceiver(event?.target?.value)
                                                           event?.target?.value?.length > 1 ? handleGetStateAndCity(event?.target?.value) : handleSetInfoStateAndCity(null, 'receiver')
                                                       }}
                                                       InputProps={{
                                                           ...params.InputProps,
                                                           endAdornment: (
                                                               <React.Fragment>
                                                                   {_loading ?
                                                                       <CircularProgress
                                                                           style={{margin: '0 5px'}}
                                                                           size={20}/>
                                                                       : null}
                                                                   {params.InputProps.endAdornment}
                                                               </React.Fragment>
                                                           ),
                                                       }}
                                            />}
                                    />
                                    {
                                        selector?.public?.validations?.state_and_city_validation_Receiver &&
                                        <p className="error">{selector?.public?.validations?.state_and_city_validation_Receiver}</p>
                                    }
                                </div>

                                <div className="col-12 col-md-6 col-lg-2">
                                    <div className="_btnGroup_blue mb-0">
                                        <button className="btnFill justify-content-center" onClick={handleReports}
                                                id="handleSearch">
                                            <span>{t("dashboard.order.t66")}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    }


                    <div className="tab">
                        <Tabs
                            id="tabs"
                            value={tabView}
                            onChange={(event, newValue) => setTabView(newValue)}
                            aria-label="wrapped label tabs example"
                        >
                            <Tab value="0" label={t("dashboard.order.t2")}/>
                            <Tab value="پرداخت شده" label={t("dashboard.order.t3")}/>
                            <Tab value="معلق" label={t("dashboard.order.t4")}/>
                            {/*<Tab value="جمع آوری" label={t("dashboard.order.t24")}/>*/}
                        </Tabs>
                    </div>

                    <div className="row">
                        {
                            listOrder?.map((item) => {
                                return (
                                    (tabView == 0 || tabView == item?.PaymentStatus) &&
                                    <div className="col-12 col-md-6 col-xl-4 d-flex" key={item?.OrderId}>
                                        <div className="cardItem">
                                            <div className="cardHeader">
                                                <div className="align-items-center">
                                                    <NegativeStore/>
                                                    <span>{item?.OrderDate}</span>
                                                </div>
                                                <div className="btnGroup_light flex-row m-0">
                                                    <button type="button"
                                                            className="btnFill  justify-content-center p-2"
                                                            onClick={() => handlerDownload(item?.OrderId)}
                                                            id="handlerDownload">
                                                        <span>{t("dashboard.order.t5")}</span>
                                                    </button>

                                                    {item?.PaymentStatus !== 'ارسال شده' &&
                                                        <>
                                                            {/* <Link to={{
                                  pathname: `/packing`, search: location?.search + '&orderId=' + item?.OrderId
                                }} className="btnFill justify-content-center p-2" id="editOrder">
                                  <span>{t("dashboard.order.t25")}</span>
                                </Link> */}

                                                            <button type="button"
                                                                    className="btnFill justify-content-center p-2"
                                                                    id="orderCancellation" onClick={() => {
                                                                setDialogCancelOrder(true)
                                                                setOrderId(item?.OrderId)
                                                            }}>
                                                                <span>{t("dashboard.order.t23")}</span>
                                                            </button>
                                                        </>
                                                    }

                                                    {/*<Link to={{*/}
                                                    {/*    pathname: `/packing`, search: createSearchParams({*/}
                                                    {/*        state: searchParams.get('state') || '',*/}
                                                    {/*        no: item?.OrderId*/}
                                                    {/*    }).toString()*/}
                                                    {/*}} type="button" className="btnFill justify-content-center p-2"*/}
                                                    {/*      id="editOrder">*/}
                                                    {/*    <span>{t("dashboard.order.t63")}</span>*/}
                                                    {/*</Link>*/}

                                                    {/*<button type="button"*/}
                                                    {/*        className="btnFill justify-content-center p-2"*/}
                                                    {/*        id="editOrder" onClick={() => handleGetShipmentList(item?.OrderId)}>*/}
                                                    {/*    <span>{t("dashboard.order.t63")}</span>*/}
                                                    {/*</button>*/}

                                                </div>
                                            </div>
                                            <div className="cardBody">
                                                <div className="title">
                                                    <div>
                                                        <h6>{t("dashboard.order.t6")}</h6>
                                                        <h6 className="orderNumber">{item?.OrderId}</h6>
                                                    </div>
                                                    <p className={item?.PaymentStatus == 'معلق' ? 'suspended' : 'paid'}>{t("dashboard.order.t7")}: {item?.PaymentStatus}</p>
                                                </div>
                                                <div className="category">
                                                    <div>
                                                        <img src={handleSetServicesLogo(item?.CategoryName)}
                                                             alt={item?.CategoryName} loading="lazy"/>
                                                        <p>{item?.CategoryName}</p>
                                                    </div>
                                                    <div className="btnGroup_light m-0">
                                                        <button className="btnEmpty justify-content-center"
                                                                onClick={() => handleDetailsOrder(item?.OrderId)}>
                                                            <span>{t("dashboard.order.t26")}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="desc">
                                                    <p>{t("dashboard.order.t8")}: {item?.OrderStatus}</p>
                                                    <p>{t("dashboard.order.t9")}: {item?.ShipmentsState}</p>
                                                    <p>{t("dashboard.order.t10")}: {item?.strBillingAddress}</p>
                                                </div>


                                                <Divider/>
                                                <div className="payment">
                                                    <div className="price">
                                                        <Wallet/>
                                                        <span> {t("dashboard.order.t12")}: {convertPrice(item?.OrderTotal)} {t("dashboard.order.t13")} </span>
                                                    </div>

                                                    {
                                                        item?.PaymentStatus == 'معلق' ? <>
                                                                <div className="btnGroup_yellow">
                                                                    <button type="button"
                                                                            disabled={selector?.loading?.isLoading}
                                                                            className="btnFill justify-content-center"
                                                                            onClick={() => getPaymentMethods(item?.OrderId, item?.OrderTotal)}
                                                                            id="getPaymentMethods"
                                                                    >
                                                                        {
                                                                            (selector?.loading?.isLoading && item?.OrderId == idOrder) ?
                                                                                <Box sx={{display: 'flex'}}>
                                                                                    <CircularProgress size={20}/>
                                                                                </Box>
                                                                                :
                                                                                <span>{t("dashboard.order.t14")}</span>
                                                                        }
                                                                    </button>
                                                                </div>
                                                            </>
                                                            :
                                                            <>
                                                                <div className="_btnGroup_light m-0">
                                                                    <button type="button" disabled
                                                                            className="btnEmpty justify-content-center">
                                                                        <span>{t("dashboard.order.t3")}</span>
                                                                    </button>
                                                                </div>
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }

                        {
                            !listOrder?.length && <div className="notFindMessage">
                                <img src={require('./../assets/img/vector/1.png')} alt="vector" loading="lazy"/>
                                <p>{t("error.t2")}</p>
                            </div>
                        }
                    </div>

                    {/*{listOrder?.length &&*/}
                    <div className="paginate">
                        <Pagination
                            count={Math.ceil(listOrder[0]?.TotalCount / pageSize)}
                            page={pageNum}
                            onChange={(event, value) => setPageNum(value)}
                            renderItem={(item) => (
                                <PaginationItem
                                    slots={{previous: ArrowBack, next: ArrowForward}}
                                    {...item}
                                />
                            )}
                        />
                    </div>
                    {/*}*/}


                </div>
            </div>


            <Dialog
                open={dialogPaymentMethods}
                onClose={() => setDialogPaymentMethods(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <div className="icon">
                        <CreditScore/>
                    </div>
                </DialogTitle>

                <DialogContent>

                    <h4>{t("dashboard.order.t15")}</h4>

                    <RadioGroup
                        id="radio"
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={radio}
                        onChange={(e) => setRadio(e.target.value)}
                    >
                        {
                            payMethods?.PaymentMethods?.map((item, index) =>
                                item?.Name !== "بانک سامان" &&
                                <FormControlLabel value={item?.PaymentMethodSystemName} control={<Radio/>}
                                                  label={item?.Name + ' ' + `${item?.PaymentMethodSystemName === "Payments.Wallet"
                                                      ? `( ${(payMethods?.RewardPointsBalance ?
                                                          convertPrice(payMethods?.RewardPointsBalance) : 0) + ' ' + t("singleOrder.invoice.t14")} )` : ''}`}/>
                            )
                        }

                    </RadioGroup>

                </DialogContent>

                <DialogActions className="_btnGroup_blue">
                    <button className="btnEmpty justify-content-center" onClick={() => setDialogPaymentMethods(false)}
                            id="closeDialogPaymentMethods">{t("dashboard.order.t16")}</button>
                    <button className="btnFill justify-content-center" disabled={selector?.loading?.isLoading}
                            onClick={() => payOrder()} id="payOrder">
                        {
                            selector?.loading?.isLoading ?
                                <Box sx={{display: 'flex'}}>
                                    <CircularProgress size={20}/>
                                </Box>
                                :
                                t("dashboard.order.t14")
                        }

                    </button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={dialogCancelOrder}
                onClose={() => setDialogCancelOrder(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <div className="icon">
                        <Close/>
                    </div>
                </DialogTitle>

                <DialogContent>
                    <h4 className="mb-5">{t("orderCancellation.t1")}</h4>

                    <div className="mb-3">
                        <p className="d-inline-block mx-2">{t("orderCancellation.t3")}: {fullName}</p>
                        <p className="d-inline-block mx-2">{t("orderCancellation.t4")}: {phone}</p>
                        <p className="d-inline-block mx-2">{t("orderCancellation.t5")}: {orderId}</p>

                    </div>

                    <div className="input">
                        <label>{t("orderCancellation.t17")}</label>
                        <textarea rows="5" value={desc} onChange={e => setDesc(e.target.value)} id="desc"
                                  ref={descRef}/>
                        {
                            validations?.desc &&
                            <p className="error">{validations?.desc}</p>
                        }
                    </div>
                </DialogContent>

                <DialogActions className="_btnGroup_blue">
                    <button className="btnEmpty justify-content-center" onClick={() => setDialogCancelOrder(false)}
                            id="closeDialogCancelOrder">{t("dashboard.order.t22")}</button>
                    <button className="btnFill justify-content-center" disabled={_isLoading} onClick={validationInput}
                            id="cancelOrder">
                        {
                            _isLoading ?
                                <Box sx={{display: 'flex'}}>
                                    <CircularProgress size={20}/>
                                </Box>
                                :
                                t("orderCancellation.t27")
                        }
                    </button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullScreen
                open={dialogDetailsOrder}
                onClose={() => setDialogDetailsOrder(false)}
                TransitionComponent={Transition}
                className="full-screen-dialog"
            >
                <AppBar sx={{position: 'relative'}}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setDialogDetailsOrder(false)}
                            aria-label="close"
                        >
                            <Close/>
                        </IconButton>
                        <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                            {t("dashboard.order.t59")}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <div className="body-calculate-dialog">
                    <div className="container">

                        <div className="item-details">
                            <div>
                                <div className="bg-item">
                                    <div className="item">
                                        <span>{t("dashboard.order.t27")}: </span>
                                        <p>{detailsItem?.orderId || '-'}</p>
                                    </div>
                                    <div className="item">
                                        <span>{t("dashboard.order.t28")}: </span>
                                        <p>{detailsItem?.shipmentId || '-'}</p>
                                    </div>
                                    <div className="item">
                                        <span>{t("dashboard.order.t29")}: </span>
                                        <p className="order-status">{detailsItem?.orderStatus || '-'}</p>
                                    </div>
                                    <div className="item">
                                        <span>{t("dashboard.order.t30")}: </span>
                                        <p className="payment-status">{detailsItem?.paymentStatus || '-'}</p>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-center p-3 ">
                                    <span>{t("dashboard.order.t31")}: </span>
                                    <p className="tracking-number">{detailsItem?.trackingNumber || t("dashboard.order.t62")}</p>
                                </div>
                            </div>
                        </div>

                        <h4>{t("dashboard.order.t10")}</h4>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t32")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.createDateTime_Sh || '-'}</p>
                                </div>
                            </div>


                            <div className="items">
                                <span>{t("dashboard.order.t36")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.se_FirstName + '  ' + detailsItem?.se_LastName}</p>
                                </div>
                            </div>
                        </div>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t38")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.se_PhoneNumber}</p>
                                </div>
                            </div>

                            <div className="items">
                                <span>{t("dashboard.order.t33")}</span>
                                <div className="bg-item">
                                    <p>{(detailsItem?.se_StateProvinceName || '-') + ' - ' + (detailsItem?.se_CityName || '-')}</p>
                                </div>
                            </div>
                        </div>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t35")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.se_Address1 || '-'}</p>
                                </div>
                            </div>
                        </div>


                        <h4>{t("dashboard.order.t11")}</h4>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t39")}</span>
                                <div className="bg-item">
                                    <p>{(detailsItem?.rs_StateProvinceName || '-') + ' - ' + (detailsItem?.rs_CityName || '-')}</p>
                                </div>
                            </div>


                            <div className="items">
                                <span>{t("dashboard.order.t42")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.rs_FirstName + '  ' + detailsItem?.rs_LastName}</p>
                                </div>
                            </div>
                        </div>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t41")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.rs_Address1 || '-'}</p>
                                </div>
                            </div>
                        </div>


                        <h4>{t("dashboard.order.t60")}</h4>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t44")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.goodsType || '-'}</p>
                                </div>
                            </div>


                            <div className="items">
                                <span>{t("dashboard.order.t45")}</span>
                                <div className="bg-item">
                                    <p>{convertPrice(detailsItem?.exactWeight) || '-'}</p>
                                </div>
                            </div>
                        </div>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t46")}</span>
                                <div className="bg-item">
                                    <p>{detailsItem?.insuranceValue || '-'}</p>
                                </div>
                            </div>
                            <div className="items">
                                <span>{t("dashboard.order.t48")}</span>
                                <div className="bg-item">
                                    <p>{convertPrice(detailsItem?.approximateValue) || '-'}</p>
                                </div>
                            </div>
                        </div>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t51")}</span>
                                <div className="bg-item">
                                    <p className="d-flex"><span> cm </span> {detailsItem?.length || '-'} </p>
                                </div>
                            </div>
                            <div className="items">
                                <span>{t("dashboard.order.t52")}</span>
                                <div className="bg-item">
                                    <p className="d-flex"><span> cm </span> {detailsItem?.width || '-'} </p>
                                </div>
                            </div>
                            <div className="items">
                                <span>{t("dashboard.order.t53")}</span>
                                <div className="bg-item">
                                    <p className="d-flex"><span> cm </span> {detailsItem?.height || '-'} </p>
                                </div>
                            </div>
                        </div>

                        <div className="item-details">
                            <div className="items">
                                <span>{t("dashboard.order.t61")}</span>
                                <div className="bg-item">
                                    <div className="item">
                                        <span>{t("dashboard.order.t50")} <b>{detailsItem?.cartonValue || '-'}</b></span>
                                    </div>
                                    <div className="item">
                                        <span>{t("dashboard.order.t54")}
                                            <b>{detailsItem?.printLogoValue || '-'}</b></span>
                                    </div>
                                    <div className="item">
                                        <span>{t("dashboard.order.t55")}
                                            <b>{detailsItem?.needCollector === "True" ? t("dashboard.order.t57") : t("dashboard.order.t58")}</b></span>
                                    </div>
                                    <div className="item">
                                        <span>{t("dashboard.order.t56")}
                                            <b>{detailsItem?.needDistributer === "True" ? t("dashboard.order.t57") : t("dashboard.order.t58")}</b></span>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Dialog>


            <Dialog
                open={dialogListOrder}
                onClose={() => setDialogListOrder(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <div className="icon">
                        <Edit/>
                    </div>
                </DialogTitle>

                <DialogContent>
                    <h4 className="mb-4">{t("dashboard.order.t64")}</h4>

                    {
                        shipmentList.map((item, index) =>
                            <div className="shipment-list mb-2" key={index}>
                                <div>
                                    <p className="d-inline-block mx-1">{t("dashboard.order.t42")}: {item?.FirstName + ' ' + item?.LastName}</p>
                                    {/*<p className="d-inline-block mx-2">{t("packing.t11")}: {phone}</p>*/}
                                    <p className="d-inline-block mx-1 address">{t("dashboard.order.t41")}: {item?.Address1} </p>
                                </div>

                                <Link to={{
                                    pathname: `/packing`, search: createSearchParams({
                                        state: searchParams.get('state') || '',
                                        no: item?.ShipmentId
                                    }).toString()
                                }} type="button" className="btnFill justify-content-center p-2"
                                      id="editOrder">
                                    <span>{t("dashboard.order.t63")}</span>
                                </Link>
                            </div>
                        )
                    }

                </DialogContent>

                <DialogActions className="_btnGroup_blue mb-0">
                    <button className="btnEmpty justify-content-center" onClick={() => setDialogListOrder(false)}
                            id="closeDialogCancelOrder">{t("dashboard.order.t22")}</button>
                </DialogActions>
            </Dialog>
        </>
    )
}
